import { Select } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';
import type { DateInputCultureInfo } from '@/utils/parseDateWithCultureInfo.ts';

const DateInputFormat = () => {
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleChange = ({ value }: { dateInputCultureInfo: string; value: string }): void => {
    sgwtWebAnalytics?.trackEvent('Header', 'user preferences, general tab, dateFormat', value);
    updateUserPreferences({ ...userPreferences, dateInputCultureInfo: value as DateInputCultureInfo });
  };

  return (
    <div className="d-flex align-items-center justify-content-between p-3 px-4 border-bottom">
      <label htmlFor="date-input-culture-info">
        <FormattedMessage id="userPreferences.label.dateInputCultureInfo" />
      </label>
      <Select
        id="date-input-culture-info"
        itemValue={(item) => item.value}
        selectedItemValue={userPreferences.dateInputCultureInfo}
        itemsAsObjects={[
          { dateInputCultureInfo: 'US (mm/dd, mm/dd,yyyy)', value: 'en' },
          { dateInputCultureInfo: 'EU (dd/mm, dd/mm/yyyy)', value: 'fr' },
        ]}
        itemToString={({ dateInputCultureInfo }) => dateInputCultureInfo}
        onChange={handleChange}
        className="w-auto"
      />
    </div>
  );
};

export default DateInputFormat;
